import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Row, Spinner } from 'react-bootstrap';
import { getUserRoles } from '../util/authUtil';

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [userRoles, setUserRoles] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            try {
                const roles = await getUserRoles();
                setUserRoles(roles);
                setIsLoading(false);
            } catch (err) {
                console.error(err);
            }
        };
        fetchData().then(r => r);
    }, []);

    useEffect(() => {
        if (!userRoles || userRoles.length === 0) {
            setIsAuthorized(false);
            return;
        }
        setIsAuthorized(userRoles.some(role => allowedRoles.includes(role)));
    }, [userRoles, allowedRoles]);

    if (isLoading) {
        return (
            <Row>
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </Row>
        );
    }

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthorized ? <Component {...props} /> : <Redirect to="/401-page" />
            }
        />
    );
};

export default PrivateRoute;
